import { AnnaError } from "@anna-money/anna-web-lib/utils";
import { CompanyProduct } from "services/companyProducts/companyProductsTypes";

export enum BillingItem {
  VirtualOffice = "VirtualOffice",
  Taxes = "Taxes",
  VatRegistration = "VatRegistration",
  ConfirmationStatement = "ConfirmationStatement",
  DirectorManagement = "DirectorManagement",
  CancellationCover = "CancellationCover",
  PayeRegistration = "PayeRegistration",
  SharesManagement = "SharesManagement",
  FormationExpress = "FormationExpress",
}

export class CompanyProductToBillingItemMapper {
  constructor(private readonly _map: { [key in CompanyProduct]?: BillingItem }) {}

  get billingItems(): BillingItem[] {
    return Object.values(this._map);
  }

  getBillingName(product: CompanyProduct): BillingItem {
    const billingItem = this._map[product];
    if (!billingItem) {
      throw new AnnaError(`No billing item assosiated with the product ${product}`);
    }
    return billingItem;
  }

  getProduct(billingItem: BillingItem): CompanyProduct {
    for (const product of Object.keys(this._map) as CompanyProduct[]) {
      if (this._map[product] === billingItem) {
        return product;
      }
    }
    throw new AnnaError(`No product assosiated with the item ${billingItem}`);
  }
}
